"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../schema");
var Result;
(function (Result) {
    Result["YES"] = "YES";
    Result["NO"] = "NO";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.YES]: {
        id: "htx.comorbidities.infectologistOpinion.result.YES",
        defaultMessage: "Igen"
    },
    [Result.NO]: {
        id: "htx.comorbidities.infectologistOpinion.result.NO",
        defaultMessage: "Nem"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.YES),
    schema_1.Schema.singleChoiceItem(Result.NO)
])
    .interpretation({ vocab: "htx", code: "seen_by_infectologist" })
    .tag({ vocab: "snomed", code: "76899008" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result });
